import { get, readable, writable } from "svelte/store";
import { createPersistentStore } from "./store";
const defaultLanguage = 'en';
const _i18n = writable(text => text);
const languagesMap = {
    'es-ES': 'es',
    'es-mx': 'es',
    'en-en': 'en',
    'fr': 'fr',
    'de': 'de',
    'it': 'it',
    'pt': 'pt',
};
export const i18n = readable(get(_i18n), set => _i18n.subscribe(set));
export const currentLanguage = createPersistentStore('currentLanguage', window.navigator.language);
currentLanguage.subscribe(async (language) => {
    try {
        const i18nMap = await getTexts(language);
        _i18n.set(text => {
            if (text in i18nMap) {
                return i18nMap[text];
            }
            console.warn(`No hay traducción para: "${text}"`);
            return text;
        });
    }
    catch (error) {
        console.error(error);
        currentLanguage.set(defaultLanguage);
    }
});
async function getTexts(language) {
    const fileName = languagesMap[language.toLowerCase()] || language;
    const response = await fetch(`/i18n/${fileName}.json`);
    if (!response.ok) {
        throw new Error('Ha ocurrido un problema al obtener el archivo de lenguaje.');
    }
    return response.json();
}
